// Hub pages + shared content for the /sc section.
import { MAJOR_PROJECTS } from "./majorProjects";
import { HOME_SERVICES } from "./homeServices";

export { MAJOR_PROJECTS, HOME_SERVICES };

export const ALL_PAGES = [
  ...MAJOR_PROJECTS.map((p) => ({ ...p, group: "major-projects" })),
  ...HOME_SERVICES.map((p) => ({ ...p, group: "home-services" })),
];

export const pageBySlug = (group, slug) => ALL_PAGES.find((p) => p.group === group && p.slug === slug);

export const LOWCOUNTRY_CITIES = [
  "Summerville", "Charleston", "North Charleston", "Goose Creek",
  "Mount Pleasant", "Ladson", "Moncks Corner", "West Ashley",
  "Georgetown", "Pawleys Island", "Murrells Inlet", "Myrtle Beach", "Conway",
];

// Shared 3-step connection process (wording differs slightly by template).
export const CONNECTION_STEPS = [
  {
    num: "01",
    title: "Tell us about your project",
    body: "Share what you need, where the property is, and your timeline through one simple request.",
  },
  {
    num: "02",
    title: "We review the details",
    body: "Home Pro Connect looks at the work involved and the location to understand the right fit.",
  },
  {
    num: "03",
    title: "Talk with the pro directly",
    body: "Discuss scope, availability, and a written estimate directly with the contractor or specialist.",
  },
];

export const HUBS = {
  "major-projects": {
    kind: "major",
    name: "Major Renovations",
    h1: "Major Renovations",
    metaTitle: "Major Renovations in SC Lowcountry | HPC",
    metaDescription: "Additions, remodels, demolition, and custom builds — Home Pro Connect connects SC Lowcountry homeowners with a general contractor for major projects.",
    intro: [
      "Big projects need more than a handyman — they need a general contractor who coordinates every trade, permit, and inspection from first sketch to final walkthrough. That's the approach behind every major project connection we make.",
      "Home Pro Connect is a connection and referral service: you tell us about your project once, we review the details, and we work to connect you with a general contractor from our network whose services and coverage area align.",
    ],
    approachTitle: "One general contractor, one coordinated project",
    approach: [
      "On a major project, dozens of decisions and half a dozen trades have to land in the right order. A general contractor owns that sequencing — demolition before rough-ins, rough-ins before drywall, finishes last — so nothing gets torn out and redone.",
      "They also handle the paperwork: permits, inspections, and scheduling with your city or county. You get one point of contact instead of juggling plumbers, electricians, and carpenters yourself.",
      "Every agreement, estimate, and timeline is between you and the contractor you choose. Our role is making the right introduction.",
    ],
    items: MAJOR_PROJECTS,
    group: "major-projects",
  },
  "home-services": {
    kind: "service",
    name: "Home Services",
    h1: "Home Service Specialist Connections in the SC Lowcountry",
    metaTitle: "Home Service Specialists in SC Lowcountry | HPC",
    metaDescription: "HVAC, plumbing, roofing, flooring, lawn care and more — Home Pro Connect connects SC Lowcountry homeowners with home service specialists. Start here.",
    intro: [
      "Not every job needs a general contractor. When the AC quits in August, a fence leans after a storm, or the lawn gets away from you, what you need is the right specialist — someone who does that one thing every day.",
      "Home Pro Connect connects you with home service specialists from our network across the Lowcountry and Grand Strand. Describe the job once, and we help find the right fit.",
    ],
    approachTitle: "The right specialist for the job",
    approach: [
      "Specialists bring focused experience: a roofer reads a roof differently than a generalist, and an HVAC tech spots a failing capacitor before it strands you in July. Matching the job to the specialist means faster diagnosis and cleaner work.",
      "It's also simpler for you. Instead of calling five companies and repeating yourself, you describe the job once — we review it and work to connect you with a specialist who covers your area.",
      "Estimates, scheduling, and service agreements are handled directly between you and the specialist. Home Pro Connect makes the introduction; the work relationship is yours.",
    ],
    items: HOME_SERVICES,
    group: "home-services",
  },
};
